program Testovnice;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  Hlavny in 'Hlavny.pas'{*.html},
  Heslo in 'Heslo.pas'{*.html},
  uSpravaOtazok in 'uSpravaOtazok.pas'{*.html},
  uEditOtazky in 'uEditOtazky.pas'{*.html},
  uStudentTest in 'uStudentTest.pas'{*.html},
  uVysledkyTestu in 'uVysledkyTestu.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TfHeslo, fHeslo);
  Application.CreateForm(TfSpravaOtazok, fSpravaOtazok);
  Application.CreateForm(TfEditOtazky, fEditOtazky);
  Application.CreateForm(TfStudentTest, fStudentTest);
  Application.CreateForm(TfVysledkyTestu, fVysledkyTestu);
  Application.Run;
end.
